import React from 'react';
import {SimulatorFeatureAppName} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {useComponent} from '../component-library';
import {IconName} from '../types';

export interface HeaderIconProps {
  featureApp: SimulatorFeatureAppName;
}
export function HeaderIcon({featureApp}: HeaderIconProps): JSX.Element {
  const Icon = useComponent('Icon');
  const Text = useComponent('Text');

  const getIconName = (): IconName => {
    switch (featureApp) {
      case SimulatorFeatureAppName.Cost:
        return 'BatteryCost';
      case SimulatorFeatureAppName.Range:
        return 'BatteryDestination';
      case SimulatorFeatureAppName.Chargetime:
        return 'BatteryCharging';
    }
  };

  return (
    <Text variant="headline" tag="h2" textAlign="start">
      <Icon name={getIconName()} size={'large'} />
    </Text>
  );
}
